/* eslint-disable indent */
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Heading from "../../../components/Heading";
import {
  Button,
  Modal,
  Row,
  Col,
  Form,
  Input,
  Select,
  message,
  Radio,
  Checkbox,
  notification,
} from "antd";
import API from "../../../api";
import urls from "../../../api/urls";
import noBagging from "../../../assests/images/middleMile/noBagging.svg";
import bag from "../../../assests/images/middleMile/bag.svg";
import white_bag_ from "../../../assests/images/middleMile/white-bag.svg";
import no_shipment from "../../../assests/images/middleMile/no-shipment.svg";
import lock_bag from "../../../assests/images/middleMile/lock-bag.svg";
import blue_bag from "../../../assests/images/guides/blue-bag.svg";
import green_bag from "../../../assests/images/guides/green-bag.svg";
import white_bag from "../../../assests/images/guides/white-bag.svg";
import yellow_bag from "../../../assests/images/guides/yellow-bag.svg";
const { CREATE_BAG, GET_ELIGIBLE_DESTINATION_HUB, GET_ALL_BAGS } = urls;
import "./style.scss";
const Bagging = () => {
  const navigate = useNavigate();
  const [baggingData, setBaggingData] = useState([]);
  const [showCreateBagModal, setShowCreateBagModal] = useState(false);
  const [hubList, setHubList] = useState([]);
  const [form] = Form.useForm();
  const [contentTypeRequired, setContentTypeRequired] = useState(false);
  const [travelByRequired, setTravelByRequired] = useState(false);
  const [eligiblePacket, setEligiblePackets] = useState([]);
  const [currentScanNum, setcurrentScanNum] = useState();
  const [enterMaxWeight, setEnterMaxWeight] = useState(false);

  const bagColor = [
    { label: <img src={blue_bag} width={35} />, value: "#2E7FE1" },
    { label: <img src={green_bag} width={35} />, value: "#70C36E" },
    { label: <img src={yellow_bag} width={35} />, value: "#D2DD3F" },
    { label: <img src={white_bag} width={35} />, value: "#fff" },
  ];

  const productType = [
    { label: "Standard", value: "standard" },
    { label: "Fast Track", value: "fast track" },
    { label: "Value Plus", value: "value plus" },
  ];

  const contentType = [
    { label: "Dox", value: "DOX" },
    { label: "Non-Dox", value: "NON-DOX" },
  ];

  const openNotification = (placement) => {
    notification.warning({
      message: "Weight Overloaded",
      duration: 1000,
      description: (
        <>
          <span style={{ color: "red" }}>
            Shipment weight is more than 20Kg. Do you want to put the shipment
            inside the bag ?
          </span>
          <hr className="divider" />
          <div className="flex-end">
            <Button
              className="save-btn"
              onClick={() => {
                setEnterMaxWeight(true);
                notification.destroy();
              }}
            >
              YES
            </Button>
            <Button
              className="cancel-btn ml-1"
              onClick={() => {
                setEnterMaxWeight(false);
                notification.destroy();
              }}
            >
              NO
            </Button>
          </div>
        </>
      ),
      placement,
    });
  };

  useEffect(() => {
    getAllBags();
    getDestinationHubs();
  }, []);

  const getAllBags = async () => {
    let response = await API.Api(GET_ALL_BAGS).getWithUserNPremiseHeader();
    if (response?.status) {
      let data = response?.response?.data;
      let eligiblePacket = data.find((e) => e.status == "CREATED");
      setEligiblePackets(eligiblePacket ? eligiblePacket : {});
      let bagDataTemp = [...data];
      let onlyBaggingData = [];
      bagDataTemp.map((e, i) => {
        if (e.bagColour) {
          if (e.status == "CREATED") {
            let z = { ...bagDataTemp[i] };
            z.bagContents = [];
            onlyBaggingData.push({ ...z, bagWeight: e.weight ? e.weight : 0 });
          } else if (e.status == "FINALISED") {
            onlyBaggingData.push({
              ...e,
              weight: e.shipmentsTotalweight,
              bagWeight: e.weight,
            });
          }
        }
      });
      setBaggingData([...onlyBaggingData]);
    }
  };

  useEffect(() => {
    let baggingDataTemp = baggingData;
    let index = baggingDataTemp.findIndex(
      (e) => e.status == "Initialized" || e.status == "CREATED"
    );
    let barCodes = [];
    if (baggingDataTemp[index]?.bagContents?.length > 0) {
      baggingDataTemp[index]?.bagContents?.map((item) =>
        barCodes.push(item.barcodeNo)
      );
    }
    if (index != -1) {
      if (barCodes.includes(currentScanNum)) {
        message.error("Barcode already scanned.");
      } else {
        if (
          eligiblePacket?.bagContents?.some(
            (e) => e.barcodeNo == currentScanNum
          )
        ) {
          let currentWeight = eligiblePacket.bagContents.find(
            (e) => e.barcodeNo == currentScanNum
          ).weight;
          if (currentWeight <= 20 || enterMaxWeight) {
            baggingDataTemp[index].weight += currentWeight;
            baggingDataTemp[index].bagContents.push({
              barcodeNo: currentScanNum,
              weight: currentWeight,
            });
            setBaggingData([...baggingDataTemp]);
          } else {
            openNotification("top");
          }
        } else if (
          eligiblePacket?.bagContents?.some((e) =>
            e.childShipments
              ? e.childShipments.some(
                  (item) => item.barcodeNo == currentScanNum
                )
              : false
          )
        ) {
          let currentChild = eligiblePacket.bagContents.find((e) =>
            e.childShipments?.find((item) => item.barcodeNo == currentScanNum)
          );

          let currentWeight = currentChild?.childShipments?.find(
            (e) => e.barcodeNo == currentScanNum
          ).weight;
          if (currentWeight <= 20 || enterMaxWeight) {
            baggingDataTemp[index].weight += currentWeight;
            baggingDataTemp[index].bagContents.push({
              barcodeNo: currentScanNum,
              weight: currentWeight,
            });
            setBaggingData([...baggingDataTemp]);
          } else {
            openNotification("top");
          }
        } else {
          message.error("Barcode is not valid for current bag");
        }
      }
    }
  }, [currentScanNum, enterMaxWeight == true]);

  //--Barcode Scanner--//
  let barcode = "";
  let interval;
  const handleKeyDown = (event) => {
    if (interval) clearInterval(interval);
    if (event.code == "Enter") {
      if (barcode) handleBarcode(barcode);
      barcode = "";
      return;
    }
    if (event.key != "Shift") barcode += event.key;
    interval = setInterval(() => (barcode = ""), 20);
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    // cleanup this component
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleBarcode = (scanned_barcode) => {
    setcurrentScanNum(parseInt(scanned_barcode));
    return scanned_barcode;
  };

  //--//

  const getDestinationHubs = async () => {
    let { response } = await API.Api(
      GET_ELIGIBLE_DESTINATION_HUB
    ).getWithAllHeaders();
    let temp = [];
    response?.data
      ?.sort((a, b) => a.destinationName.localeCompare(b.destinationName))
      .map((e) => {
        temp.push({
          value: e.destinationHubId,
          label: e.destinationName
            .split(" ")
            .map((e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase())
            .join(" "),
          key: e.destinationHubId,
        });
      });
    setHubList(temp);
  };

  const createBag = async (values) => {
    let payload = { ...values };
    let response = await API.Api(CREATE_BAG).postIdHeader(payload);
    if (response.status) {
      if (response?.response?.data?.bagContents?.length > 0) {
        setEligiblePackets(response?.response?.data);
        if (
          (values.modeList == "fast track" ||
            values.modeList == "value plus") &&
          values.bagColour == "#70C36E"
        ) {
          values["title"] = values.modeList;
          values["status"] = "Initialized";
          values["bagContents"] = [];
          values["weight"] = 0;
          values["bagWeight"] = 0;
          setBaggingData([values, ...baggingData]);
        } else {
          values["status"] = "Initialized";
          values["bagContents"] = [];
          values["weight"] = 0;
          values["bagWeight"] = 0;
          setBaggingData([values, ...baggingData]);
        }
      } else {
        message.error("No eligible shipments for this bag.");
      }
      setShowCreateBagModal(false);
      form.resetFields();
      setTravelByRequired(false);
    } else {
      message.error(response?.response?.data?.message);
    }
  };

  const changeMode = (e) => {
    let length = e.length;
    switch (length) {
      case 1: {
        if (e[0] == "standard") {
          setContentTypeRequired(true);
          let contentType = form.getFieldValue("contentTypeList");
          if (contentType[0] == "DOX") {
            form.setFieldsValue({ bagColour: "#2E7FE1" });
          } else {
            let travelBy = form.getFieldValue("travelBy");
            form.setFieldsValue({
              bagColour:
                travelBy == "air"
                  ? "#D2DD3F"
                  : travelBy == "surface"
                  ? "#fff"
                  : "",
            });
          }
        } else {
          setContentTypeRequired(false);
          form.setFieldsValue({ bagColour: "#70C36E" });
          form.setFieldsValue({ travelBy: "air" });
        }
        break;
      }
    }
  };

  const changeContentType = (e) => {
    let length = e.length;
    if (contentTypeRequired) {
      switch (length) {
        case 1: {
          if (e[0] == "DOX") {
            setTravelByRequired(false);
            form.setFieldsValue({ bagColour: "#2E7FE1" });
          } else {
            setTravelByRequired(true);
            let travelBy = form.getFieldValue("travelBy");
            form.setFieldsValue({
              bagColour:
                travelBy == "air"
                  ? "#D2DD3F"
                  : travelBy == "surface"
                  ? "#fff"
                  : "",
            });
          }
          break;
        }
      }
    }
  };

  const changeTravelBy = (e) => {
    if (travelByRequired) {
      form.setFieldsValue({
        bagColour:
          e.target.value == "air"
            ? "#D2DD3F"
            : e.target.value == "surface"
            ? "#fff"
            : "",
      });
    }
  };

  const postBagContents = async (content, bagId, bagWeight) => {
    let payload = {
      weight: parseFloat(bagWeight),
      bagContents: content,
    };
    let response = await API.Api(CREATE_BAG + `/${bagId}/content`).postIdHeader(
      payload
    );
    if (response.status) {
      let response1 = await API.Api(
        CREATE_BAG + `/${bagId}/status/FINALISED`
      ).putIdHeader();
      if (response1.status) {
        let baggingDataTemp = baggingData;
        let index = baggingDataTemp.findIndex((e) => e.bagBarcodeNo == bagId);
        baggingDataTemp[index].status = "FINALISED";
        setBaggingData([...baggingDataTemp]);
      }
    } else {
      message.error("Failed.");
    }
  };

  const bagWeightChange = (e, id) => {
    let baggingDataTemp = baggingData;
    let index = baggingDataTemp.findIndex((item) => item.bagBarcodeNo == id);

    let { value } = e.target;
    const regex = /^\d{1,3}(\.\d{0,2})?$/;
    if (regex.test(value) || value === "") {
      baggingDataTemp[index].bagWeight = value;
      setBaggingData([...baggingDataTemp]);
    }
  };

  return (
    <div className="p-2-tab">
      <Heading title={"Bagging"} />
      <div className="master-main-container bagging-div">
        <div className="space-between p-1">
          <Input
            className="w-20"
            onKeyPress={(e) => {
              // eslint-disable-next-line no-constant-condition
              if (e.key == "Enter") {
                setcurrentScanNum(parseInt(e.target.value));
              }
            }}
          />
          <Button
            className={
              baggingData.some((e) => e.status != "FINALISED")
                ? "btn-style ml-1"
                : "save-btn ml-1"
            }
            onClick={() => setShowCreateBagModal(true)}
            disabled={baggingData.some((e) => e.status != "FINALISED")}
          >
            + CREATE BAG
          </Button>
        </div>
        <hr className="divider" />
        {baggingData?.length > 0 ? (
          <Row>
            {baggingData.map((e, i) => {
              return (
                <Col
                  sm={23}
                  lg={7}
                  xl={7}
                  md={11}
                  xs={23}
                  key={i}
                  className="bag-design"
                >
                  {e.status == "FINALISED" && (
                    <div
                      style={{
                        position: "absolute",
                        zIndex: 100,
                        width: "100%",
                        height: "100",
                      }}
                    >
                      <div className="center" style={{ marginTop: "38%" }}>
                        <img src={lock_bag} />
                      </div>
                    </div>
                  )}

                  <div
                    style={{
                      background: e.bagColour,
                      borderTopLeftRadius: "5px",
                      borderTopRightRadius: "5px",
                    }}
                  >
                    <p
                      className="d-flex"
                      style={{ borderBottom: "1px solid #dddddd" }}
                    >
                      {e.bagColour == "#fff" ? (
                        <img src={white_bag_} className="ml-1" />
                      ) : (
                        <img src={bag} className="ml-1" />
                      )}
                      <span
                        style={{
                          padding: "0.5rem",
                          display: "block",
                          color: e.bagColour == "#fff" ? "#444444" : "#fff",
                          textTransform: "capitalize",
                        }}
                      >
                        {e.bagColour == "#70C36E"
                          ? "Green Bag"
                          : e.bagColour == "#2E7FE1"
                          ? "Blue Bag"
                          : e.bagColour == "#D2DD3F"
                          ? "Yellow Bag"
                          : "White Bag"}
                      </span>
                      <span
                        style={{
                          color: e.bagColour == "#fff" ? "#444444" : "#fff",
                          paddingTop: "0.5rem",
                        }}
                      >
                        ( {e.bagBarcodeNo} )
                      </span>
                    </p>
                  </div>

                  {e?.bagContents?.length > 0 ? (
                    <div style={{ height: "250px" }}>
                      <div style={{ height: "55%", overflowX: "scroll" }}>
                        {e.bagContents.map((e, i) => {
                          return (
                            <p
                              key={i}
                              style={{
                                borderBottom: "1px solid #EEEEEE",
                                marginTop: "-10px",
                                padding: "5px 1.2rem",
                              }}
                            >
                              {e.barcodeNo}
                            </p>
                          );
                        })}
                      </div>
                      <div
                        style={{
                          background: "#F3F3F3",
                          padding: "0.4rem",
                          fontWeight: 500,
                        }}
                      >
                        Shipment Weight :{" "}
                        {(Math.round(e?.weight * 100) / 100).toFixed(2)}
                      </div>
                      <div style={{ padding: "0.5rem 1rem" }}>
                        <span>Booking Weight</span>
                        <br />
                        <div className="space-between">
                          <Input
                            style={{
                              background: "#F7F7F7",
                              borderRadius: "5px",
                              width: "60%",
                            }}
                            onChange={(event) =>
                              bagWeightChange(event, e.bagBarcodeNo)
                            }
                            value={e.bagWeight}
                            disabled={e.status == "FINALISED"}
                          />
                          <Button
                            className={
                              e.status == "FINALISED" || e.bagWeight <= 0
                                ? "btn-style"
                                : "save-btn"
                            }
                            disabled={
                              e.status == "FINALISED" || e.bagWeight <= 0
                            }
                            onClick={() =>
                              postBagContents(
                                e.bagContents,
                                e.bagBarcodeNo,
                                e.bagWeight
                              )
                            }
                          >
                            FINALIS{e.status == "FINALISED" ? "ED" : "E"}
                          </Button>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="center" style={{ marginTop: "25%" }}>
                      <img src={no_shipment} />
                    </div>
                  )}
                </Col>
              );
            })}
          </Row>
        ) : (
          <div className="center" style={{ height: "80%" }}>
            <img src={noBagging} alt="bagging" />
          </div>
        )}
        <div>
          <hr className="divider" />
          <div className="d-flex flex-end p-1">
            <Button
              htmlType="submit"
              className="save-btn ml-1"
              onClick={() => navigate("/middle-mile")}
            >
              DONE
            </Button>
          </div>
        </div>
      </div>
      <Modal
        title={"Create Bag"}
        open={showCreateBagModal}
        onCancel={() => {
          form.resetFields();
          setShowCreateBagModal(false);
          setContentTypeRequired(false);
          setTravelByRequired(false);
        }}
        width={450}
        footer={null}
        className="create-bag"
        style={{ top: "200px !important" }}
        maskClosable={false}
      >
        <Form
          layout="vertical"
          form={form}
          scrollToFirstError={{
            behavior: "smooth",
            block: "center",
            inline: "center",
          }}
          onFinish={createBag}
          className="global-form"
          name="form"
        >
          <Row gutter={20} className="global-form-row">
            <Col span={24}>
              <Form.Item
                name="modeList"
                label="Product"
                rules={[
                  { required: true, message: "Please choose product type." },
                ]}
              >
                <Checkbox.Group
                  className="d-flex"
                  options={productType}
                  onChange={changeMode}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="contentTypeList"
                label="Content type"
                rules={[
                  {
                    required: contentTypeRequired,
                    message: "Please choose content type.",
                  },
                ]}
              >
                <Checkbox.Group
                  className="d-flex"
                  options={contentType}
                  onChange={changeContentType}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="travelBy"
                label="Mode"
                rules={[
                  {
                    required: travelByRequired,
                    message: "Please choose mode.",
                  },
                ]}
              >
                <Radio.Group onChange={changeTravelBy}>
                  <Radio value="surface">
                    <span className="f-14" style={{ color: "#061624" }}>
                      Surface
                    </span>
                  </Radio>
                  <Radio value="air" className="ml-1">
                    <span className="f-14" style={{ color: "#061624" }}>
                      Air
                    </span>
                  </Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                name="bagBarcodeNo"
                label="Bag number"
                rules={[
                  {
                    required: true,
                    message: "Please enter bag number",
                  },
                ]}
              >
                <Input
                  placeholder="Bag number"
                  autoComplete="off"
                  onKeyPress={(e) => {
                    if (/[^0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                    if (e.target.value.length === 11) {
                      e.preventDefault();
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                name="destinationHubId"
                label="Bag destination"
                rules={[
                  {
                    required: true,
                    message: "Please select bag destination",
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Bag destination"
                  options={hubList}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                name="bagColour"
                label="Choose bag"
                rules={[
                  {
                    required: true,
                    message: "Please select bag colour",
                  },
                ]}
              >
                <Radio.Group>
                  {bagColor.map((e, i) => {
                    return (
                      <Radio value={e.value} key={i}>
                        <span className="f-14" style={{ color: "#061624" }}>
                          {e.label}
                        </span>
                      </Radio>
                    );
                  })}
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
          <div className="d-flex flex-end p-1">
            <Button htmlType="submit" className="save-btn ml-1">
              CREATE
            </Button>
          </div>
        </Form>
      </Modal>
    </div>
  );
};
export default Bagging;
